import { applyMiddleware, compose, createStore } from "redux";
import createRootReducer from "./reducer";
import createRootSaga from "./sagas";
import createSagaMiddleware from "redux-saga";
import { OPEN } from "./ducks/cardMenu";

const sagaMiddleware = createSagaMiddleware();

export default function configureStore(preloadedState) {
  const actionSanitizer = (action) =>
    action.type === OPEN && action.cardMenu
      ? { ...action, cardMenu: `<<${action.cardMenu.id}>>` }
      : action;
  const stateSanitizer = (state) =>
    state.cardMenu && state.cardMenu.cardMenu
      ? {
          ...state,
          cardMenu: {
            ...state.cardMenu,
            cardMenu: `<<${state.cardMenu.cardMenu.id}>>`,
          },
        }
      : state;

  const composeEnhancers =
    process.env.REACT_APP_BASENAME === "/" &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
          actionSanitizer,
          stateSanitizer,
          trace: true,
          traceLimit: 25,
        })
      : compose;
  const store = createStore(
    createRootReducer(),
    preloadedState,
    composeEnhancers(applyMiddleware(sagaMiddleware))
  );

  sagaMiddleware.run(createRootSaga);

  return store;
}
